<script lang="ts">
    import {Question} from "../../models/Question";

    export let question: Question
</script>

<div class="question-header">
    <div class="header">{question.text}</div>
</div>

<style lang="scss">
  @use "../../../component_scss_library/questions";
</style>
